module.exports = __webpack_public_path__ + "img/2015-08_bloomberg.a5e2ad80.jpg";